import React, { useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Grid, IconButton } from '@mui/material';
import TmFullButton from '../../../common/buttons/TmFullButton';
import TmPlus from '../../../../icons/TmPlus';
import { ShowForPermission } from '../../../common/permissions/ShowForPermission';
import { CategoryType } from '../../../../models/enums/categoryType';
import { PermissionType } from '../../../../models/enums/permissionType';
import { AddExistDispatcherModal } from '../dialogs/AddExistDispatcherModal';
import { EditDispatcherModal } from '../../../dispatchers/edit/EditDispatcherModal';
import { useAddCompanyContext } from '../context/AddCompanyContextProvider';
import { Dispatcher } from '../models/dispatcher';

interface AddDispatchersTabProps {
    onNext: () => void;
}

export const AddDispatchersTab: React.FC<AddDispatchersTabProps> = ({ onNext }) => {
    const { dispatchers, setDispatchers, companyId } = useAddCompanyContext();
    const [isDispatcherModalOpen, setDispatcherModalOpen] = useState(false);
    const [isCreateDispatcherModalOpen, setCreateDispatcherModalOpen] = useState(false);

    const handleDispatcherAdded = (dispatcher: Dispatcher): void => {
        setDispatchers((prev) => [...prev, dispatcher]);
    };

    const handleSkip = () => {
        onNext();
    };

    return (
        <Box sx={{ textAlign: 'center', width: '100%', mx: 'auto' }}>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item>
                    <Typography variant="h6" sx={{ textAlign: 'left', mb: 2 }} component="div">
                        Диспетчеры
                    </Typography>
                </Grid>
                <Grid item xs={12} sm="auto">
                    <ShowForPermission catalog={CategoryType.Companies} permission={PermissionType.Add}>
                        <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'flex-end' }, flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                            <IconButton sx={{ display: "flex" }} className="list-item" onClick={() => setDispatcherModalOpen(true)}>
                                <TmPlus fill="none" stroke="white" />&nbsp;
                                <Typography fontWeight="bold" pr={1} component="span">
                                    &nbsp;Добавить диспетчера
                                </Typography>
                            </IconButton>
                            <IconButton sx={{ display: "flex" }} className="list-item-outline" onClick={() => setCreateDispatcherModalOpen(true)}>
                                <TmPlus fill="none" stroke="#9588e8" />&nbsp;
                                <Typography fontWeight="bold" pr={1} component="span">
                                    &nbsp;Создать диспетчера
                                </Typography>
                            </IconButton>
                        </Box>
                    </ShowForPermission>
                </Grid>
            </Grid>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: '100%' }}>ФИО</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dispatchers.length === 0 ? (
                            <TableRow>
                                <TableCell align="center">
                                    <Typography sx={{ color: '#999999', mt: 3, mb: 3, textAlign: 'center' }} component="div">
                                        У вас пока не добавлен ни один диспетчер
                                        <br />
                                        <Typography sx={{ fontSize: '0.85rem', textAlign: 'center' }} component="div">
                                            Диспетчеров можно добавить сейчас или позже в карточке клиента
                                        </Typography>
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            dispatchers.map((dispatcher) => (
                                <TableRow key={dispatcher.id}>
                                    <TableCell sx={{ fontWeight: "bold", verticalAlign: 'top' }}>{dispatcher.fullName}</TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <TmFullButton sx={{ marginTop: 2 }} onClick={handleSkip}>
                {dispatchers.length > 0 ? 'Далее' : 'Пропустить'}
            </TmFullButton>

            <AddExistDispatcherModal
                open={isDispatcherModalOpen}
                onClose={() => setDispatcherModalOpen(false)}
                onSave={handleDispatcherAdded}
                companyId={companyId!}
                existingDispatcherIds={dispatchers.map((d) => d.id)}
            />

            <EditDispatcherModal
                open={isCreateDispatcherModalOpen}
                onClose={() => setCreateDispatcherModalOpen(false)}
                onAddingSuccess={handleDispatcherAdded}
                isAdding={true}
                companyId={companyId!}
            />
        </Box>
    );
};
